<template>
    <div class="detail-page">
        <div class="page-header">
            <div>
                <div class="page-title">违规积分详情</div>
                <div class="page-subtitle">
                    账户：{{ accountName || '--' }} / 广告账户ID：{{ advertiserId || '--' }}
                </div>
            </div>
            <div class="header-actions">
                <el-button @click="$router.back()">返回</el-button>
                <el-button type="primary" plain @click="refreshCurrentTab">刷新</el-button>
            </div>
        </div>

        <div class="filter-card">
            <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <el-tab-pane label="违规记录" name="violation">
                    <div class="filter-row">
                        <el-select v-model="filters.status" clearable placeholder="状态" class="filter-item">
                            <el-option label="全部" value="" />
                            <el-option label="生效中" value="VALID" />
                            <el-option label="已失效" value="INVALID" />
                        </el-select>
                        <el-input
                            v-model.trim="filters.eventId"
                            placeholder="事件ID"
                            clearable
                            class="filter-item"
                            @keyup.enter.native="searchViolation"
                        />
                        <el-input
                            v-model.trim="filters.illegalType"
                            placeholder="违规类型"
                            clearable
                            class="filter-item"
                            @keyup.enter.native="searchViolation"
                        />
                        <el-date-picker
                            v-model="filters.dateRange"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="filter-item date-range"
                        />
                        <el-button type="primary" @click="searchViolation">搜索</el-button>
                        <el-button @click="resetViolationFilters">重置</el-button>
                    </div>

                    <el-table :data="violationData" border stripe v-loading="violationLoading" style="width: 100%">
                        <el-table-column prop="eventId" label="事件ID" min-width="120" />
                        <el-table-column prop="status" label="状态" width="110">
                            <template slot-scope="{ row }">
                                <el-tag size="mini" :type="statusTagType(row.status)">
                                    {{ formatStatus(row.status) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="illegalType" label="违规类型" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="score" label="扣分值" width="100" />
                        <el-table-column prop="createTime" label="发生时间" min-width="170" />
                        <el-table-column prop="adId" label="广告ID" min-width="120" />
                        <el-table-column prop="materialId" label="素材ID" min-width="120" />
                        <el-table-column prop="rejectReason" label="违规原因" min-width="320" show-overflow-tooltip />
                        <el-table-column label="证据" width="100">
                            <template slot-scope="{ row }">
                                <el-link v-if="row.evidenceUrl" :href="row.evidenceUrl" type="primary" target="_blank">
                                    查看
                                </el-link>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination-wrap">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="violationPage.pageIndex"
                            :page-size="violationPage.pageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="violationPage.total"
                            @current-change="handleViolationPageChange"
                            @size-change="handleViolationSizeChange"
                        />
                    </div>
                </el-tab-pane>

                <el-tab-pane label="处置记录" name="disposal">
                    <el-table :data="disposalData" border stripe v-loading="disposalLoading" style="width: 100%">
                        <el-table-column prop="disposalId" label="处置ID" min-width="120" />
                        <el-table-column prop="disposalAction" label="处置动作" min-width="140" />
                        <el-table-column prop="disposalStatus" label="处置状态" min-width="120" />
                        <el-table-column prop="disposalTerm" label="处置期限" min-width="140" />
                        <el-table-column prop="disposalScore" label="关联积分" min-width="100" />
                        <el-table-column prop="disposalStartTime" label="开始时间" min-width="170" />
                        <el-table-column prop="disposalEndTime" label="结束时间" min-width="170" />
                        <el-table-column prop="description" label="说明" min-width="260" show-overflow-tooltip />
                    </el-table>

                    <div class="pagination-wrap">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="disposalPage.pageIndex"
                            :page-size="disposalPage.pageSize"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="disposalPage.total"
                            @current-change="handleDisposalPageChange"
                            @size-change="handleDisposalSizeChange"
                        />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
export default {
    name: 'violationRecordDetails',
    data() {
        return {
            activeTab: 'violation',
            advertiserId: '',
            accountName: '',
            initialEventId: '',
            messageId: '',
            violationRequestId: 0,
            disposalRequestId: 0,
            violationLoading: false,
            disposalLoading: false,
            violationData: [],
            disposalData: [],
            routeReady: false,
            filters: {
                status: '',
                eventId: '',
                illegalType: '',
                dateRange: []
            },
            violationPage: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            disposalPage: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.initFromRoute()
    },
    methods: {
        initFromRoute() {
            this.advertiserId = this.$route.query.advertiserId || ''
            this.accountName = this.$route.query.name || ''
            this.initialEventId = this.$route.query.eventId || ''
            this.messageId = this.$route.query.messageId || ''
            this.activeTab = this.$route.query.tab === 'disposal' ? 'disposal' : 'violation'
            if (this.initialEventId && this.activeTab === 'violation') {
                this.filters.eventId = this.initialEventId
                this.filters.status = ''
            } else {
                this.filters.eventId = ''
                this.filters.status = 'VALID'
            }
            if (this.advertiserId) {
                this.routeReady = true
                this.refreshCurrentTab()
                return
            }
            if (!this.messageId) {
                this.routeReady = true
                this.refreshCurrentTab()
                return
            }
            this.resolveRouteByMessageId()
        },
        resolveRouteByMessageId() {
            this.$axios.post({
                url: '/qianchuanViolationMessage/detail',
                data: {
                    messageId: this.messageId
                },
                loading: false,
                success: (res) => {
                    const detail = res.code === 0 ? res.data : null
                    if (detail) {
                        this.advertiserId = detail.advertiserId || this.advertiserId
                        this.accountName = detail.advertiserName || this.accountName
                        if (!this.initialEventId && detail.eventType !== 'DISPOSAL') {
                            this.initialEventId = this.normalizeNumericQueryValue(detail.eventId) || ''
                        }
                        if (detail.eventType === 'DISPOSAL') {
                            this.activeTab = 'disposal'
                        }
                        if (this.initialEventId && this.activeTab === 'violation') {
                            this.filters.eventId = this.initialEventId
                            this.filters.status = ''
                        }
                    }
                    this.routeReady = true
                    this.refreshCurrentTab()
                },
                error: () => {
                    this.routeReady = true
                    this.refreshCurrentTab()
                }
            })
        },
        handleTabChange() {
            if (this.activeTab === 'violation') {
                this.fetchViolationData()
                return
            }
            this.fetchDisposalData()
        },
        refreshCurrentTab() {
            if (!this.routeReady) {
                return
            }
            if (this.activeTab === 'violation') {
                this.fetchViolationData()
            } else {
                this.fetchDisposalData()
            }
        },
        searchViolation() {
            this.violationPage.pageIndex = 1
            this.fetchViolationData()
        },
        resetViolationFilters() {
            this.filters = {
                status: this.initialEventId && this.activeTab === 'violation' ? '' : 'VALID',
                eventId: this.initialEventId && this.activeTab === 'violation' ? this.initialEventId : '',
                illegalType: '',
                dateRange: []
            }
            this.violationPage.pageIndex = 1
            this.fetchViolationData()
        },
        fetchViolationData() {
            if (!this.advertiserId) {
                this.$message.error('缺少广告账户ID')
                return
            }
            const requestId = ++this.violationRequestId
            const eventId = this.normalizeNumericQueryValue(this.filters.eventId)
            const status = eventId ? undefined : (this.filters.status || undefined)
            this.violationLoading = true
            this.$axios.post({
                url: '/qianchuanViolationMonitor/detail',
                data: {
                    advertiserId: this.advertiserId,
                    status,
                    eventId,
                    illegalType: this.filters.illegalType || undefined,
                    startTime: this.filters.dateRange && this.filters.dateRange.length ? this.filters.dateRange[0] : undefined,
                    endTime: this.filters.dateRange && this.filters.dateRange.length ? this.filters.dateRange[1] : undefined,
                    pageIndex: this.violationPage.pageIndex,
                    pageSize: this.violationPage.pageSize
                },
                success: (res) => {
                    if (requestId !== this.violationRequestId) {
                        return
                    }
                    this.violationLoading = false
                    if (res.code !== 0 || !res.data) {
                        this.$message.error(res.msg || '加载违规明细失败')
                        return
                    }
                    this.violationData = res.data.content || []
                    this.violationPage.total = res.data.totalElements || 0
                },
                error: () => {
                    if (requestId !== this.violationRequestId) {
                        return
                    }
                    this.violationLoading = false
                    this.$message.error('加载违规明细失败')
                }
            })
        },
        fetchDisposalData() {
            if (!this.advertiserId) {
                this.$message.error('缺少广告账户ID')
                return
            }
            const requestId = ++this.disposalRequestId
            this.disposalLoading = true
            this.$axios.post({
                url: '/qianchuanViolationMonitor/disposal',
                data: {
                    advertiserId: this.advertiserId,
                    pageIndex: this.disposalPage.pageIndex,
                    pageSize: this.disposalPage.pageSize
                },
                success: (res) => {
                    if (requestId !== this.disposalRequestId) {
                        return
                    }
                    this.disposalLoading = false
                    if (res.code !== 0 || !res.data) {
                        this.$message.error(res.msg || '加载处置明细失败')
                        return
                    }
                    this.disposalData = res.data.content || []
                    this.disposalPage.total = res.data.totalElements || 0
                },
                error: () => {
                    if (requestId !== this.disposalRequestId) {
                        return
                    }
                    this.disposalLoading = false
                    this.$message.error('加载处置明细失败')
                }
            })
        },
        handleViolationPageChange(pageIndex) {
            this.violationPage.pageIndex = pageIndex
            this.fetchViolationData()
        },
        handleViolationSizeChange(pageSize) {
            this.violationPage.pageSize = pageSize
            this.violationPage.pageIndex = 1
            this.fetchViolationData()
        },
        handleDisposalPageChange(pageIndex) {
            this.disposalPage.pageIndex = pageIndex
            this.fetchDisposalData()
        },
        handleDisposalSizeChange(pageSize) {
            this.disposalPage.pageSize = pageSize
            this.disposalPage.pageIndex = 1
            this.fetchDisposalData()
        },
        formatStatus(status) {
            if (!status) return '--'
            const map = {
                VALID: '生效中',
                INVALID: '已失效',
                DISPOSAL: '已处置'
            }
            return map[status] || status
        },
        statusTagType(status) {
            if (status === 'VALID') return 'danger'
            if (status === 'INVALID') return 'info'
            return ''
        },
        normalizeNumericQueryValue(value) {
            if (value === null || value === undefined || value === '') {
                return undefined
            }
            const text = String(value).trim()
            return /^\d+$/.test(text) ? text : undefined
        }
    }
}
</script>

<style scoped>
.detail-page {
    padding: 24px;
    background: #f5f7fb;
    min-height: calc(100vh - 48px);
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
}

.page-title {
    font-size: 26px;
    font-weight: 700;
    color: #1f2a44;
}

.page-subtitle {
    margin-top: 8px;
    font-size: 14px;
    color: #7b8190;
}

.header-actions {
    display: flex;
    gap: 12px;
}

.filter-card {
    background: #fff;
    border-radius: 16px;
    padding: 16px 18px;
    box-shadow: 0 10px 30px rgba(15, 35, 95, 0.06);
}

.filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
}

.filter-item {
    width: 180px;
}

.date-range {
    width: 340px;
}

.pagination-wrap {
    padding: 18px 0 10px;
    display: flex;
    justify-content: flex-end;
}

@media (max-width: 1024px) {
    .page-header {
        align-items: flex-start;
    }

    .filter-item,
    .date-range {
        width: 100%;
    }
}
</style>
